/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./DropDownItem.module.scss";

const DropDownItem = ({ children, value, onClick, handleClose, className, ...rest }) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(value);
    }
    handleClose();
  }, [value, onClick, handleClose]);

  return (
    <div className={cx(styles.dropDownItem, className)} onClick={handleClick} {...rest}>
      {children}
    </div>
  );
};

DropDownItem.defaultProps = {
  className: undefined,
  onClick: undefined,
  handleClose: () => {}
};

DropDownItem.propTypes = {
  /** If passed it will overwrite default onSelect function */
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  value: PropTypes.any.isRequired,
  className: PropTypes.string,
  handleClose: PropTypes.func
};

export default DropDownItem;
